import React from 'react'
import { useUser } from '../../redux/services/authSlice'
import { GrMoney } from "react-icons/gr";

const Dashboard = () => {
  const {user} = useUser()
  return (
    <div className="flex items-center gap-6 bg-white border border-[#DBE0E6] rounded-lg py-4 px-8 max-w-[400px]">
    <div className="bg-blue-50 p-3 rounded-full">
      <GrMoney size={28} color='#124699'/>
    </div>
    <div>
      <p className="text-md text-gray-500">Wallet Balance</p>
      <h2 className="text-2xl font-bold text-gray-800">
        ₹ {user?.walletBalance || 0}
      </h2>
    </div>
  </div>
  )
}

export default Dashboard
